import { useEffect, useState } from 'react';
import Lottie from 'react-lottie-player';
import { NB } from '@cerebral-inc/ui';
import data from './data.json';

const { Center, useMediaQuery } = NB;
export interface ILottieAnimationProps {
  segments: [number, number];
}
const LottieAnimation = ({ segments }: ILottieAnimationProps): JSX.Element => {
  const [isMobile] = useMediaQuery({ minWidth: 0, maxWidth: 480 });
  const [isPlayVideo, setIsPlayVideo] = useState(!isMobile);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (!isPlayVideo) {
      timeout = setTimeout(() => {
        setIsPlayVideo(true);
      }, 900);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [isPlayVideo]);

  return (
    <Center>
      <Center
        position="fixed"
        bottom={{ base: '89px', md: 0 }}
        zIndex={1}
        maxW="400px"
        h="103px"
      >
        <Lottie
          animationData={data}
          play={isPlayVideo}
          segments={segments}
          loop={false}
          direction={1}
          style={{ width: '400px' }}
        />
      </Center>
    </Center>
  );
};

export default LottieAnimation;
